import React from 'react';
import VanGoghBlogPost from './VanGoghBlogPost';

const FoundingDayStory = () => {
  return (
    <VanGoghBlogPost
      title="Philly Grit, a Corgi Named Kelce & the Birth of Poser AI™"
      subtitle="A breakfast in Florida, an Iverson hoodie, and the decision to finally bet on myself."
      date="November 15, 2025"
      author="Jim Bukowski"
      authorTitle="Founder & CEO, WestBay Group"
      category="Founding Day"
      heroImage="/jim-bukowski-profile.jpg"
      tags={[
        "Poser AI™",
        "Founder Story",
        "🦅 Philly Grit",
        "🎖️ Veteran-Owned",
        "November 15, 2025"
      ]}
    >
      <p>
        I'm originally from <strong>Philadelphia</strong> — and if you know anything about Philly, you know how deep the passion runs. The Birds, the energy, the grit, the underdog spirit — it shaped me. That city made me tough, made me real, and taught me that heart matters as much as talent.
      </p>

      <p>
        And yeah, I'm still that guy in Florida wearing an <strong>Iverson #3 hoodie</strong>.
      </p>

      <h2>Meet Kelce 🐾</h2>

      <p>
        Philly pride shows up in my life every day… even in the form of my corgi, <strong>Kelce</strong> — named after one of the greatest Eagles of all time. He's my partner, my shadow, and has been with me through the highest highs and the darkest lows.
      </p>

      <p>
        On <strong>November 15, 2025</strong>, I was sitting outside a small breakfast spot in Florida, wearing my trusty Iverson 3 hoodie, Kelce staring up at me like he always does, waiting for a piece of toast.
      </p>

      <p>
        It wasn't a corporate boardroom moment. It wasn't champagne and investors. It was just <strong>me, my dog, my breakfast, and the belief that it was finally time to bet on myself.</strong>
      </p>

      <h2>Built on Real Grit</h2>

      <p>
        That's what Poser AI™ is built on — not ego, not flash — but real life, real resilience, and real American grit.
      </p>

      <p>
        Just like Philly. Just like the Navy. Just like everything I've overcome to get here.
      </p>

      <h2>The Journey</h2>

      <p>
        I didn't come from privilege. I grew up homeless and dropped out of high school because surviving each day was the only priority. But I never stopped showing up.
      </p>

      <p>
        I joined the <strong>U.S. Navy</strong>, earned my GED, and served through September 11th — a period that shaped my values and identity forever. <em>Honor, Courage, and Commitment</em> weren't just slogans; they became the structure I built my entire life on.
      </p>

      <h2>Cloud Security Expertise</h2>

      <p>
        After the Navy, I built my career in cloud security and DevOps:
      </p>

      <ul>
        <li><strong>AWS Certified Solutions Architect</strong></li>
        <li><strong>HashiCorp Terraform Certified</strong></li>
        <li>30+ years of real-world experience</li>
        <li>Built solutions for Fortune 500 companies</li>
      </ul>

      <h2>The Breaking Point</h2>

      <p>
        In 2023, I lost my mother. That loss shattered me — but it also freed me.
      </p>

      <p>
        I realized I'd been building everyone else's dreams while putting my own on hold. I was making other people rich, solving other people's problems, but never betting on myself.
      </p>

      <h2>The Rebirth</h2>

      <p>
        I relocated to Florida, bought a Cadillac Lyriq as a symbol of reinvention, and started building Poser AI™.
      </p>

      <p>
        <strong>All of it self-funded.</strong><br />
        <strong>All of it self-built.</strong><br />
        <strong>All of it earned through a lifetime of showing up.</strong>
      </p>

      <p>
        This is the American dream — lived in real time. And I'm just getting started. 🦅🐾
      </p>
    </VanGoghBlogPost>
  );
};

export default FoundingDayStory;